













































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CompositePlot extends Vue {

    height = 300;
    ymax: (number|null) = null;
    ymin: (number|null) = null;
    fixed = 0;

    years: number[] = [];

    @Prop() readonly edaAwards: any;
    @Prop() readonly cutters: any;

    constructor() {
        super();

        for(let year = 2012; year <= 2018; ++year) {
            this.years.push(year);
        }

        //find ymin/max
        const findMinMax = (vs: number[], sdevs?: number[])=>{
            vs.forEach((v, index)=>{
                if(v == null) return;
                let vmin = v;
                let vmax = v;
                if(sdevs) {
                    vmin -= sdevs[index];
                    vmax += sdevs[index];
                }
                if(this.ymin === null || this.ymin > vmin) this.ymin = vmin;
                if(this.ymax === null || this.ymax < vmax) this.ymax = vmax;
            });
        }

        findMinMax(this.cutters.county);
        findMinMax(this.cutters.states.avg, this.cutters.states.sdev);
        findMinMax(this.cutters.us.avg, this.cutters.us.sdev);

        if(this.ymin == null) return;
        if(this.ymax == null) return;

        //add a bit of space top/bottom
        const r = this.ymax - this.ymin;
        this.ymax += r/5;
        this.ymin -= r/5;
    }

    lineCommand = (point: number, i: number) => `L ${this.itox(i)} ${this.ptoy(point)}`

    ptoy(p: number) {
        if(this.ymin == null) return;
        if(this.ymax == null) return;

        const per = (p - this.ymin)/(this.ymax - this.ymin);
        return (this.height-30) - (this.height - 40)*per;
    }

    itox(y: number) {
        return ((1000-200)/(this.years.length-1))*y+150;
    }

    t2x(date: string) {
        const d = new Date(date);
        const begin = new Date("2012-01-01").getTime();
        const end = new Date("2020-01-01").getTime();
        const duration = end - begin;
        const x = ((1000-150)/duration)*(d.getTime()-begin)+100;
        return x;
    }

    a2h(amount: number) {
        return amount/100000+1;
    }

    sdevPath(points: number[], sdev: number[], command: any) {
        let d = "";

        //top
        for(let i = 0;i < points.length; ++i) {
            if(i == 0) d += 'M '+this.itox(i)+','+this.ptoy(points[i]+sdev[i]);
            else d+= command(points[i]+sdev[i], i);
        } 
        //bottom
        for(let i = points.length-1;i >= 0; --i) {
            d+= command(points[i]-sdev[i], i);
        } 
        return d;
    }

    svgPath(points: number[], command: any) {
        const d = points.reduce((acc: string, point: number, i: number)=>{
            if(i === 0) return `M ${this.itox(i)},${this.ptoy(point)}`
            else return `${acc} ${command(point, i)}`
        }, '')
        return d;
    }

    get yticks() {
        if(this.ymin == null) return [];
        if(this.ymax == null) return [];

        const ticks: number[] = [];

        //compute optimal min/max step
        const range = this.ymax - this.ymin;

        const step = range/4;
        if(range < 0.025) this.fixed = 2;

        const min = Math.round(this.ymin/step)*step;
        const max = this.ymax;
        for(let p = min;p <= max;p+=step) {
            const y = this.ptoy(p);
            if(y !== undefined && y > this.height-30) continue;
            ticks.push(p);
        }
        return ticks;
    }
}
